import React from "react";
import styled from "styled-components";

const G = styled.g`
  stroke: ${props => props.theme.icon};
  fill: ${props => (props.selected ? props.theme.icon : "none")};
`;

const ChannelIcon = ({ selected }) => {
  if (window.innerWidth > 1800) {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="30.965"
        height="30.514"
        viewBox="0 0 30.965 30.514"
      >
        <G selected={selected} transform="translate(1 1)">
          <circle
            cx="5.875"
            cy="5.875"
            r="5.875"
            strokeMiterlimit="10"
            strokeWidth="2"
          />
          <circle
            cx="5.875"
            cy="5.875"
            r="5.875"
            transform="translate(17.215)"
            strokeMiterlimit="10"
            strokeWidth="2"
          />
          <circle
            cx="5.875"
            cy="5.875"
            r="5.875"
            transform="translate(0 16.765)"
            strokeMiterlimit="10"
            strokeWidth="2"
          />
          <circle
            cx="5.875"
            cy="5.875"
            r="5.875"
            transform="translate(17.215 16.765)"
            strokeMiterlimit="10"
            strokeWidth="2"
          />
          <line
            y2="5.015"
            transform="translate(5.875 11.75)"
            strokeMiterlimit="10"
            strokeWidth="2"
          />
          <line
            x2="5.465"
            transform="translate(11.75 22.639)"
            strokeMiterlimit="10"
            strokeWidth="2"
          />
          <line
            y1="8.722"
            x2="8.722"
            transform="translate(10.103 9.844)"
            strokeMiterlimit="10"
            strokeWidth="2"
          />
        </G>
      </svg>
    );
  } else {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="18.924"
        height="18.646"
        viewBox="0 0 18.924 18.646"
      >
        <G
          selected={selected}
          transform="translate(-18.5 -322.539)"
          strokeMiterlimit="10"
        >
          <ellipse
            cx="3.636"
            cy="3.636"
            rx="3.636"
            ry="3.636"
            transform="translate(19 323.039)"
          />
          <ellipse
            cx="3.636"
            cy="3.636"
            rx="3.636"
            ry="3.636"
            transform="translate(29.653 323.039)"
          />
          <ellipse
            cx="3.636"
            cy="3.636"
            rx="3.636"
            ry="3.636"
            transform="translate(19 333.414)"
          />
          <ellipse
            cx="3.636"
            cy="3.636"
            rx="3.636"
            ry="3.636"
            transform="translate(29.653 333.414)"
          />
          <line y2="3.104" transform="translate(22.636 330.31)" />
          <line x2="3.382" transform="translate(26.271 337.049)" />
          <line y1="5.398" x2="5.398" transform="translate(25.252 329.131)" />
        </G>
      </svg>
    );
  }
};

export default ChannelIcon;
